import { Star } from 'lucide-react'
import { useLocale } from '../i18n/LocaleContext'
import { useTestimonials } from '../hooks/useTestimonials'
import SectionHeading from './ui/SectionHeading'

export default function Testimonials() {
  const { locale, t } = useLocale()
  const { testimonials, loading } = useTestimonials()

  // Testimonials are entirely CMS-driven: the section is hidden until real
  // testimonials exist (no placeholder fallback).
  if (loading || testimonials.length === 0) return null

  return (
    <section className="section-padding bg-surface">
      <div className="container-max">
        <SectionHeading title={t.testimonials.title} subtitle={t.testimonials.subtitle} />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-card p-6 shadow-subtle hover:shadow-hover transition-shadow"
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star
                    key={i}
                    size={16}
                    className={i < item.rating ? 'text-warning fill-warning' : 'text-gray-200'}
                  />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-text-secondary text-sm leading-relaxed mb-6">
                &ldquo;{item.quote[locale]}&rdquo;
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-3">
                {item.parentPhoto ? (
                  <img
                    src={item.parentPhoto}
                    alt={item.parentName}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                ) : (
                  <div
                    role="img"
                    aria-label={item.parentName}
                    className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center"
                  >
                    <span aria-hidden="true" className="text-primary font-medium text-sm">
                      {item.parentName.split(' ').map((n) => n[0]).join('')}
                    </span>
                  </div>
                )}
                <div>
                  <p className="text-sm font-medium text-secondary">{item.parentName}</p>
                  <p className="text-xs text-text-muted">
                    {t.testimonials.childAge}: {item.childAge} | {item.campYear}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
